
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white dark:bg-benchr-950 border-t border-benchr-100 dark:border-benchr-800/50">
      <div className="container max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Logo and info */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img
                src="/lovable-uploads/1c526186-3a81-4e24-a103-1d15cab1f0ae.png"
                alt="benchr.ai Logo"
                className="h-32 md:h-40 w-auto" // Augmenté encore plus, de h-20/h-28 à h-32/h-40
              />
            </Link>
            <p className="text-benchr-600 dark:text-benchr-400 mb-6 max-w-md">
              Powerful e-commerce competitive intelligence platform to help businesses analyze competitors and gain actionable insights.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-benchr-100 dark:border-benchr-800/50 flex flex-col md:flex-row justify-between items-center">
          <p className="text-benchr-600 dark:text-benchr-400 text-sm">
            © {currentYear} Benchr, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
